// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { Category } from "./category";
import { Interface } from "./interface";
import { Key, KeyT } from "./key";

/**
 * One wire key produced by array expansion, with its base entry.
 */
export class ExpandedKey implements flatbuffers.IUnpackableObject<ExpandedKeyT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ExpandedKey {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  key(obj?: Key): Key | null {
    return (obj || new Key()).__init(this.bb_pos, this.bb!);
  }

  entry(): number {
    return this.bb!.readUint32(this.bb_pos + 12);
  }

  index(): number {
    return this.bb!.readUint16(this.bb_pos + 16);
  }

  static sizeOf(): number {
    return 20;
  }

  static createExpandedKey(
    builder: flatbuffers.Builder,
    key_iface: Interface,
    key_category: Category,
    key_id: number,
    key_sub_id: number,
    entry: number,
    index: number,
  ): flatbuffers.Offset {
    builder.prep(4, 20);
    builder.pad(2);
    builder.writeInt16(index);
    builder.writeInt32(entry);
    builder.prep(4, 12);
    builder.writeInt32(key_sub_id);
    builder.writeInt32(key_id);
    builder.pad(2);
    builder.writeInt8(key_category);
    builder.writeInt8(key_iface);
    return builder.offset();
  }

  unpack(): ExpandedKeyT {
    return new ExpandedKeyT(
      this.key() !== null ? this.key()!.unpack() : null,
      this.entry(),
      this.index(),
    );
  }

  unpackTo(_o: ExpandedKeyT): void {
    _o.key = this.key() !== null ? this.key()!.unpack() : null;
    _o.entry = this.entry();
    _o.index = this.index();
  }
}

export class ExpandedKeyT implements flatbuffers.IGeneratedObject {
  constructor(
    public key: KeyT | null = null,
    public entry: number = 0,
    public index: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    return ExpandedKey.createExpandedKey(
      builder,
      this.key?.iface ?? 0,
      this.key?.category ?? 0,
      this.key?.id ?? 0,
      this.key?.subId ?? 0,
      this.entry,
      this.index,
    );
  }

  clone(): ExpandedKeyT {
    const obj = new ExpandedKeyT();
    obj.key = this.key !== null ? this.key!.clone() : null;
    obj.entry = this.entry;
    obj.index = this.index;
    return obj;
  }

  equals(other: ExpandedKeyT): boolean {
    if (this.key !== null && other.key !== null) {
      if (!this.key!.equals(other.key!)) return false;
    } else if (this.key !== other.key) return false;
    if (this.entry !== other.entry) return false;
    if (this.index !== other.index) return false;
    return true;
  }
}
